import { render, staticRenderFns } from "./AgendaMeetingDetailsCard.vue?vue&type=template&id=cf56620e&scoped=true&"
import script from "./AgendaMeetingDetailsCard.vue?vue&type=script&lang=js&"
export * from "./AgendaMeetingDetailsCard.vue?vue&type=script&lang=js&"
import style0 from "./AgendaMeetingDetailsCard.vue?vue&type=style&index=0&id=cf56620e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf56620e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VIcon,VRow,VTooltip})
